export default __webpack_public_path__ + "static/media/110-hotel-1.a70f35d8.svg";